module.exports = __webpack_public_path__ + "static/media/btnAppleStore.c5768268.svg";